module.exports = __webpack_public_path__ + "img/pose-m-14.e148ec20.png";